var React = require('react');

function OpenFinanceHeader (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M5.8335 20L14.1154 11.4998L20.0441 17.5848C22.823 13.4917 27.8781 8.09522 35.0002 5.28433M35.0002 5.28433L31.4908 3.33331M35.0002 5.28433L34.3219 9.45576","stroke":"#00E0FF","strokeWidth":"2","strokeLinecap":"square","strokeLinejoin":"round","key":0}),React.createElement("rect",{"x":"5.8335","y":"25.4167","width":"5.83333","height":"8.75","rx":"1","stroke":"#011642","strokeWidth":"2","key":1}),React.createElement("rect",{"x":"16.6665","y":"21.6667","width":"6.66667","height":"12.5","rx":"1","stroke":"#011642","strokeWidth":"2","key":2}),React.createElement("rect",{"x":"28.75","y":"15","width":"5.83333","height":"19.1667","rx":"1","stroke":"#011642","strokeWidth":"2","key":3})]);
}

OpenFinanceHeader.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = OpenFinanceHeader;

OpenFinanceHeader.default = OpenFinanceHeader;
